import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const AudioControl = ({ url, id, caller }) => {
  return (
    <figure className="mt20">
      <figcaption>Listen to recording from {caller} </figcaption>
      <br />
      <a href={url} target='_blank'>Click here to download recording.</a>
      <br />
      <audio id={`${id}`} controls className="mt10 ">
        <source src={url} type="audio/mpeg" />
        <figcaption className="mtb10">
          This browser may not support playback of this audio file. Try accessing it using this
          <Link to={url}>link</Link> instead.
        </figcaption>
      </audio>
      <a className='btn btn-default audio-btns' style={{  float: 'left', width: 'auto', margin: '13px' }} onClick={(e) => {
        var player = document.getElementById(id);
        player.currentTime += 15;
      }}>
        <i className='fa fa-forward'></i> 15 sec
      </a>
      <a className='btn btn-default audio-btns' style={{ float: 'right', width: 'auto', margin: '13px' }} onClick={(e) => {
        var player = document.getElementById(id);
        player.currentTime -= 15;
        console.log(player.currentTime);
      }}>
        <i className='fa fa-backward'></i> 15 sec
      </a>
    </figure>
  );
};

export default AudioControl;
